import { render, staticRenderFns } from "./IRDetails.vue?vue&type=template&id=73d50fbf&scoped=true&"
import script from "./IRDetails.vue?vue&type=script&lang=js&"
export * from "./IRDetails.vue?vue&type=script&lang=js&"
import style0 from "./IRDetails.vue?vue&type=style&index=0&id=73d50fbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d50fbf",
  null
  
)

export default component.exports